import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import React from 'react';

export default function StatusIcon({
  ok,
}: {
  ok: boolean;
}): React.ReactElement {
  const { token } = theme.useToken();

  if (ok) {
    return <CheckCircleOutlined style={{ color: token.colorSuccess }} />;
  }

  return <CloseCircleOutlined style={{ color: token.colorError }} />;
}
